import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { LazyImage } from "components"
import { productUnitsSymbol } from "constant"
import { calculateItemSalePrice, thousandSeparator } from "utils"
import classes from "./OrderDetailsItem.module.scss"

const OrderDetailsItem = props => {
  const { orderItem, isPaid } = props

  const [t, i18n] = useTranslation()

  const salePrice =
    calculateItemSalePrice(orderItem)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const specificationItems = orderItem.orderItemSpecifications.flatMap(item =>
    item.specificationItems
  )
  const wholeItems = specificationItems.filter(item => !item.portion || item.portion === "whole")
  const firstHalfItems = specificationItems.filter(item => item.portion === "firstHalf")
  const secondHalfItems = specificationItems.filter(item => item.portion === "secondHalf")

  const renderItems = items => items.map(specificationItem =>
    <div
      key={`${specificationItem.builderStepKey || "whole"}-${specificationItem.specificationItemId}`}
      className={classes["addOn"]}
    >
      <div className={clsx(classes["pill"], isLtr && classes["pill-ltr"])}>
        {specificationItem.name}
        {!specificationItem.isSelectable &&
          <Fragment>
            <MdClose />
            {specificationItem.quantity * orderItem.quantity}
          </Fragment>
        }
      </div>
      {specificationItem.salePrice > 0 &&
        <div className={classes["price"]}>
          {thousandSeparator(
            specificationItem.salePrice *
            (specificationItem.quantity - specificationItem.freeQuantity) *
            orderItem.quantity
          )}
        </div>
      }
    </div>
  )

  const renderPortion = (faTitle, enTitle, items) => items.length > 0 &&
    <section className={classes["portion"]}>
      <div className={classes["portion-title"]}>
        {i18n.language === "fa" ? faTitle : enTitle}
      </div>
      {renderItems(items)}
    </section>

  return (
    <Fragment>
      <div className={classes["container"]}>
        <LazyImage
          src={orderItem.foodImageCover}
          imageWidth={200}
          quality={80}
          className={clsx(
            classes["image"],
            isLtr && classes["image-ltr"]
          )}
        />
        <div className={classes["left"]}>
          <div className={classes["info"]}>
            <div className={classes["row"]}>
              <span>{t("کد_کالا")}:</span>
              <span
                className={clsx(
                  classes["code"],
                  isLtr && classes["code-ltr"]
                )}
              >
                {orderItem.foodCode}
              </span>
            </div>
            <div
              className={clsx(
                classes["foodName"],
                isLtr && classes["foodName-ltr"]
              )}
            >
              {orderItem.foodName}
            </div>
            {
              !orderItem.isSimple &&
              <div>{orderItem.option.name}</div>
            }
            <div
              className={clsx(
                classes["pill"],
                isLtr && classes["pill-ltr"]
              )}
            >
              {thousandSeparator(salePrice)}{" "}
              <MdClose />{" "}
              {orderItem.quantity}{t(productUnitsSymbol[orderItem.unit])}
            </div>
          </div>
        </div>

        <div
          className={clsx(
            classes["right"],
            isLtr && classes["right-ltr"]
          )}
        >
          <div className={classes["price"]}>
            {thousandSeparator(
              salePrice * orderItem.quantity
            )}
          </div>
          {
            orderItem.systemDiscount > 0 &&
            <div className={classes["price"]}>
              {thousandSeparator(-orderItem.systemDiscount)}
            </div>
          }
          {
            orderItem.addAmount > 0 &&
            <div className={classes["price"]}>
              + {thousandSeparator(orderItem.addAmount)}
            </div>
          }
          {
            isPaid &&
            <div className={classes["paid"]}>
              {t("پرداخت_شده")}
            </div>
          }
        </div>
      </div>

      {renderItems(wholeItems)}
      {renderPortion("نیمه اول", "First half", firstHalfItems)}
      {renderPortion("نیمه دوم", "Second half", secondHalfItems)}
    </Fragment>
  )
}

export default OrderDetailsItem
